import 'slick-carousel';
import 'bootstrap';
import { reloadicons } from './svg.js';
import { closeAllMenus } from './mobile.js';
import { dispatchViewCartEvent } from './events.js';
import { pageLoadingOn, pageLoadingOff, showRatingWhenInView , openNav, closeNav, hideOverlay, validateForm, copyTextToClipboard, ajaxForms, getUserDevice, setCookie, IsCEP, setZipcodeTypingFormatter, loadHeaderPurchaseListCarrousel, generateSha256} from './utilities.js';
import Modal from 'bootstrap/js/dist/modal';
import '../../themes/main.css'
import '../../themes/sabores-de-whisky.css'
import '../../themes/carrinho/carrinho.css'
import { addCart } from './carrinho.js';
import { DataLayerEvents } from './datalayer/data-layer-events.js';
import lozad from 'lozad';
import './group-product-price.js';

jQuery(async function () {
	const lozadObsever = lozad();
	lozadObsever.observe();
	// O Slick com infinite cria clones depois do observe() acima (e de novo a cada refresh),
	// e o lozad nao enxerga esses clones: sem isto eles ficam sem foto.
	// O refresh por largura de tela dispara breakpoint; o refresh manual nao dispara evento nenhum
	$(document).on("init reInit breakpoint", ".slick-slider", function () {
		lozadObsever.observe();
	});
	await import('./svg.js');
	await import('./carrinho.js');
	await import('./mobile.js');
	await import('jquery-ui/ui/widgets/autocomplete');
	await import('./rating/star-rating.js');
	await import('./rating/theme.js');
	await import('./favoritos.js');
	const { default: Blazy } = await import('blazy');

	if ($("#loader").length > 0) {
		$("#loader").fadeOut("");
	}

	$('button.loading-button').attr('disabled', false)
	$('button.loading-button').removeClass("loading-button")
	$('.banner-placeholder').remove()
	

	$('.continuar-compra-btn').on('click', function () {
		closeNav();
	});

	setZipcodeTypingFormatter();

	if(navigator.userAgent.match("Instagram")){
		$(".box-login-social .google-login-box").css("display","none");
	}

	/*
	* Fecha o alert
	*/
	$('body').on('click', '.alert a.close', function () {
		if ($(this).parent().parent().hasClass('has-error')) {
			$(this).parent().removeAttr("style");
			$(this).parent().addClass("displaynone");
			$(this).parent().parent().removeClass('has-error');
			if ($(this).parent().hasClass('alert-add')) {
				$(this).parent().remove();
			}
		} else {
			$(this).parent().removeAttr("style");
			$(this).parent().addClass("displaynone");
		}
	});

	/**
	* Receber código de acesso por e-mail
	*/
	$("body").on("click",".code-access-button",function(){  
		pageLoadingOn();
		var form = $(this).closest("form");
		var email = form.find('input[name=email]').val();
		if (email==undefined){
			email = form.find('input[name=identificacao]').val();
		}
		if (email==undefined || email==""){
			form.find('.alert-danger').html('<a class="close" title="Fechar">×</a>');
			form.find('.alert-danger').append('<p>Informe o seu E-mail no campo acima.</p>');
			form.find('.alert-danger').removeClass('displaynone');
			pageLoadingOff();
			return;
		}
		var site_key = $('input[name=g-recaptcha-response]').attr("data-sitekey");
		var action_name =  $('input[name=g-recaptcha-response]').attr("data-action");
		grecaptcha.ready(function() {
			grecaptcha.execute(site_key, {action: action_name})
			.then(function(token) {
				$('.alert-danger').html('');
				$('.alert-danger').addClass('displaynone');
				$('.alert-success').html('');
				$('.alert-success').addClass('displaynone');
				$.ajax({
					type: "POST",
					url: "/login/",
					data: "acessoRapidoEmail="+email+"&g-recaptcha-response="+token,
					dataType: "json",
					success: function(json){
						if (json.error!=undefined){
							form.find('.alert-danger').html('<a class="close" title="Fechar">×</a>');
							form.find('.alert-danger').append('<p>'+json.error+'</p>');
							form.find('.alert-danger').removeClass('displaynone');
						}
						if (json.success!=undefined){
							form.find('.alert-danger').addClass('displaynone');
							form.find('.alert-success').html('<a class="close" title="Fechar">×</a>');
							form.find('.alert-success').append('<p>'+json.success+'</p>');
							form.find('.alert-success').removeClass('displaynone');
						}
						pageLoadingOff();
					},
					error: function(){
						form.find('.alert-danger').html('<a class="close" title="Fechar">×</a>');
						form.find('.alert-danger').append('<p>Erro inesperado, tente novamente.</p>');
						form.find('.alert-danger').removeClass('displaynone');
						pageLoadingOff();
					}
				});	
			});
		});
	});

	/*
		Menu todos departamentos
	*/
	$('#overlay-geral ').mouseout(function () {
		var anterior = $('.toda-loja').find('.active-menu-d');
		anterior.removeClass('active-menu-d');
		anterior.addClass('d-none');
	});

	const setModalZipRegionUnavailable = (zipcode, alertError) => {
		const zip = zipcode.replace(/\D/g, "");
		if ((zip >= "69300000" && zip <= "69399999") || (zip >= "76800000" && zip <= "76999999")) {
			alertError.append('<p>Desculpe, não estamos enviando os produtos para sua região.</p>');
			alertError.append('<p>No momento, compras on-line é apenas com a retirada dos produtos na Loja física em Rua 135, 140 Setor Marista, Goiânia – GO, 74180-020</p>');
			alertError.append('<p>Em breve iremos enviar para todo Brasil, assine nossa newsletter e fique por dentro.</p>');
			alertError.append('<p>Em caso de dúvidas, entre em contato pelo e-mail: <strong><a href="mailto:faleconosco@casadabebida.com.br">faleconosco@casadabebida.com.br</a></strong> ou pelo telefone: <strong>(62) 3142-8288</strong>.</p>');
			alertError.append('<p>Obrigado.</p>');
			// alertError.append('<p>Informe o seu E-mail no campo acima.</p>');
			alertError.removeClass('displaynone');
			return true;
		}
		return false;
	}

	$('form#form-zipcode-header, form-zipcode-header-mobile').on("keypress", function(e) {
		if (e.key === "Enter") {
			e.preventDefault();
			e.stopImmediatePropagation();
			$(this).trigger("submit");
		}
	});
	/* Seta o cep pelo header */
	$('form#form-zipcode-header').on("submit", function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		let zipcode = $("form#form-zipcode-header input[name=zipcode-header]").val();

		const form = $(e.target);
		const alertError = form.find('.alert-danger');
		alertError.addClass('displaynone');
		alertError.html("");
		const regionUnavailable = setModalZipRegionUnavailable(zipcode, alertError);
		if (regionUnavailable) return true;

		if (IsCEP(zipcode)) {
			if(zipcode.indexOf("-") != 5) zipcode = zipcode.slice(0, 5) + "-" + zipcode.slice(5);
			setCookie("zipcode", zipcode, 30);
			$(".informe-cep-container-desktop .informe-cep-desktop .value").html(zipcode);
			$('.cep-modal').removeClass('active');
			$('#overlay-geral').removeClass("active");
			//Preenche o cep na pagina do produto
			$('#productZipcode').val(zipcode);
			//Preenche o cep no carrinho de compras
			$('#purchaseListZipcode').attr('value',zipcode);
			$('.purchase-list-footer .carriers').html('');
		} else {
			$("form#form-zipcode-header").find('.main-alert').html('<a class="close" title="Fechar">×</a>');
			$("form#form-zipcode-header").find('.main-alert').append('<p><span/>Informe o Cep para cadastro</p>');
			$("form#form-zipcode-header").find('.main-alert').fadeIn();
			$("form#form-zipcode-header").find('.main-alert').removeClass("displaynone");
		}

		if (!regionUnavailable) {
			closeAllNavbarMenu();
			inativeAllNavebarMenu();
		}
	});


	$('form#form-zipcode-header-mobile').on("submit", function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		let zipcode = $("form#form-zipcode-header-mobile input[name=cep-modal]").val();

		const form = $(e.target);
		const alertError = form.find('.alert-danger');
		alertError.addClass('displaynone');
		alertError.html("");
		const regionUnavailable = setModalZipRegionUnavailable(zipcode, alertError);
		if (regionUnavailable) return true;
		
		if (IsCEP(zipcode)) {
			if(zipcode.indexOf("-") != 5) zipcode = zipcode.slice(0, 5) + "-" + zipcode.slice(5);

			setCookie("zipcode", zipcode, 30);

			$(".informe-cep-container .cep-button").html(zipcode);
			$('.cep-modal').removeClass('active');
			$('#overlay-geral').removeClass("active");
			$("html").css("overflow", "auto")
			//Preenche o cep na pagina do produto
			$('#productZipcode').val(zipcode);
			//Preenche o cep no carrinho de compras
			$('#purchaseListZipcode').attr('value',zipcode);
			$('.purchase-list-footer .carriers').html('');
		}else{
			$("form#form-zipcode-header-mobile").find('.main-alert').html('<a class="close" title="Fechar">×</a>');
			$("form#form-zipcode-header-mobile").find('.main-alert').append('<p><span/>Informe o Cep para cadastro</p>');
			$("form#form-zipcode-header-mobile").find('.main-alert').fadeIn();
			$("form#form-zipcode-header-mobile").find('.main-alert').removeClass("displaynone");
		}
	});


	$(".toda-loja .item-menu>a").on({
		'mouseover': function (e) {
			var anterior = $('.toda-loja-itens.active-menu-d');
			anterior.removeClass('active-menu-d');
			anterior.addClass('d-none');
			var url = $(this).attr('data-url');
			//console.log(url);
			var ul = $('.toda-loja-itens#' + url);
			ul.removeClass('d-none');
			ul.addClass('active-menu-d');
		},
	});

	/*
	* Autocomplete da busca
	*/
	var cache = {}, lastXhr;
	//var autoMax = $('#form-search input').outerWidth();
	$("input.search-topo").autocomplete({
		minLength: 2,
		position: {
			my: "left top",
			at: "left bottom"
		},
		source: function (request, response) {
			var term = request.term;
			if (term in cache) {
				response(cache[term]);
				return;
			}
			lastXhr = $.getJSON("/pesquisa/", request, function (data, status, xhr) {
				var results;
				if (xhr === lastXhr) {
					results = $.map(data, function (item) {
						return {
							value: item.value,
							img: item.img,
							label: item.label,
							id: item.id,
							price: item.price,
							total: item.total
						};
					});
					cache[term] = results;
					response(results);
				}
			});
		},
		create: function () {
			$(this).data("uiAutocomplete")._renderItem = function (ul, item) {
				if (item.label == 'inicio') {
					return $("<li/>").appendTo(ul);

				} else if (item.label == 'final') {
					return $("<li/>")
						.data("item.autocomplete", item)
						.append("<a class='final'>Ver todos os " + item.total + " produtos </a>")
						.appendTo(ul);
				} else if (item.label == 'categoria') {
					return $("<li/>")
						.data("item.autocomplete", item)
						.append("<a class='categoria'>" + item.value + "</a>")
						.appendTo(ul);
				} else if (item.label == 'categorias') {
					return $("<li/>")
						.data("item.autocomplete", item)
						.append("<span class='categorias'>" + item.value + "</span>")
						.appendTo(ul);
				} else if (item.label == 'suggestion') {
					return $("<li/>")
						.data("item.autocomplete", item)
						.append("<a class='suggestion'> " + item.value + "</a>")
						.appendTo(ul);
				} else {
					if (item.value != null) {
						return $("<li/>")
							.data("item.autocomplete", item)
							.append("<a class='result'><div class='img'><img src='" + item.img + "' /></div><div class='info'><div class='name'>" + item.value + "</div><div class='price'>" + item.price + "</div></div></a>")
							.appendTo(ul);
					}
				}
			}
		},
		select: function (event, ui) {
			window.location.href = ui.item.id;
		}
	});
	$("input.search-menu").autocomplete({
		minLength: 2,
		position: {
			my: "center top",
			at: "center bottom"
		},
		source: function (request, response) {
			var term = request.term;
			if (term in cache) {
				response(cache[term]);
				return;
			}
			lastXhr = $.getJSON("/pesquisa/", request, function (data, status, xhr) {
				var results;
				if (xhr === lastXhr) {
					results = $.map(data, function (item) {
						return {
							value: item.value,
							img: item.img,
							label: item.label,
							id: item.id,
							price: item.price,
							total: item.total
						};
					});
					cache[term] = results;
					response(results);
				}
			});
		},
		create: function () {
			$(this).data("uiAutocomplete")._renderItem = function (ul, item) {
				if (item.label == 'inicio') {
					return $("<li/>").appendTo(ul);

				} else if (item.label == 'final') {
					return $("<li/>")
						.data("item.autocomplete", item)
						.append("<a class='final'>Ver todos os " + item.total + " produtos </a>")
						.appendTo(ul);
				} else if (item.label == 'categoria') {
					return $("<li/>")
						.data("item.autocomplete", item)
						.append("<a class='categoria'>" + item.value + "</a>")
						.appendTo(ul);
				} else if (item.label == 'categorias') {
					return $("<li/>")
						.data("item.autocomplete", item)
						.append("<span class='categorias'>" + item.value + "</span>")
						.appendTo(ul);
				} else if (item.label == 'suggestion') {
					return $("<li/>")
						.data("item.autocomplete", item)
						.append("<a class='suggestion'> " + item.value + "</a>")
						.appendTo(ul);
				} else {
					if (item.value != null) {
						return $("<li/>")
							.data("item.autocomplete", item)
							.append("<a class='result'><div class='img'><img src='" + item.img + "' /></div><div class='info'><div class='name'>" + item.value + "</div><div class='price'>" + item.price + "</div></div></a>")
							.appendTo(ul);
					}
				}
			}
		},
		select: function (event, ui) {
			window.location.href = ui.item.id;
		}
	});

	var bLazy = new Blazy({
		offset: 20,
		selector: '.b-lazy',
	});
	$(".form-search-header").on("click", "i", function () {
		var form = $(this).parent();
		var term = form.find('input').val();

		if (term == "") {
			if (form.find('input').hasClass("active")) {
				form.find('input').removeClass("active");
			} else {
				form.find('input').addClass("active");
				form.find('input').focus();
			}
		} else {
			form.submit();
		}
	});
	$('.blog-sabores-whisky').slick({
		dots: true,
		arrows: false,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 3,
		touchThreshold: 1000,
		slidesToScroll: 3,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		]
	});
	$('.produto-whisky-caroussel').slick({
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 4,
		touchThreshold: 1000,
		slidesToScroll: 1,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	});

	$('.ofertas-relampago-carousel').slick({
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 6,
		touchThreshold: 1000,
		slidesToScroll: 1,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	});

	$('.cards-caroussel').slick({
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 5,
		touchThreshold: 1000,
		slidesToScroll: 1,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					dots: true,
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: true,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: true,
				}
			}
		]
	});
	$('.produto-mini-carousel').slick({
		dots: true,
		arrows: false,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 3,
		touchThreshold: 1000,
		slidesToScroll: 3,
		//lazyLoad: 'ondemand',
	});$('.produto-mini-carousel').slick("refresh");

	$('.complementares-carousel').slick({
		dots: true,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 4,
		touchThreshold: 1000,
		slidesToScroll: 4,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
		]
	});

	$('.text-header-carousel').slick({
		dots: false,
		arrows: false,
		infinite: false,
		vertical: true,
		verticalSwiping: false,
		autoplay: true,
		draggable: false,
		swipe: false,
		touchMove: false,
		slidesToShow: 1,
		touchThreshold: 1000,
		slidesToScroll: 1,
		lazyLoad: 'ondemand',
	});

	$('#text-header').on('click', 'a', function (e) {
		if (!window.getSelection().isCollapsed) {
			e.preventDefault();
		}
	});

	$('#copyright .copy button.scrollTop, #copyrightDesktop button.scrollTop').on("click", () => {
		$('html,body').animate({
      scrollTop: 0
    }, 400);
	})

	// Display none no menu quando chegar no fim da página
	$(document).on("scroll", function() {
		if ($(window).width() <= 991) {
			if($(window).scrollTop() + $(window).height() == $(document).height()) {
				$('#mobile-navbar').hide();
			}else {
				$('#mobile-navbar').show();
			}
		}
	});

	$(".product-thumb .mc-qtd-btns input[name='amount']").on("keyup", function () {
		const currentAmount = $(this).val()
		const supply = $(this).data('supply')
		const period = $(this).data('period')

		if (period == 0 && currentAmount > supply) {
			$(this).closest('.product-thumb-info').find('.alertsupply').removeClass('displaynone')
			$(this).val(supply)
		} else {
			if (!$(this).closest('.product-thumb-info').find('.alertsupply').hasClass('displaynone')) {
				$(this).closest('.product-thumb-info').find('.alertsupply').addClass('displaynone')
			}
		}
	})

	$(".product-thumb .mc-qtd-btns input[name='amount']").on("blur", function () {	
		const currentAmount = $(this).val()

		if (!currentAmount) {
			$(this).val(1)
		}
	})

	// NEW MENU

	const list = document.querySelectorAll("#mobile-navbar .list");
	list.forEach((item) => item.addEventListener("click", activeLink));

	function activeLink() {
		
		const isActive = this.classList.contains("active") ? true : false

		inativeAllNavebarMenu();
		closeAllNavbarMenu();
		
		if(!isActive) {
			this.classList.add("active");
			$("html").css("overflow", "hidden")
			const classDropdown = this.dataset.dropdown;
			$(`.dropdown.${classDropdown}`).toggleClass("active");

			if (classDropdown === "menu-cart-dropdown") loadHeaderPurchaseListCarrousel(true);

			$('#overlay-geral').toggleClass("active");
		}
	}

	//Mobile
	$("#mobile-navbar .menu-login-dropdown form .input-group span.iconpasswordeye").on("click", () => {
		const inputType = $("#loginPass1").prop("type")
		if (inputType === 'password') {
			$("#loginPass1").prop("type", "text");
			return;
		}

		$("#loginPass1").prop("type", "password");
	})
	//Desktop
	$("#form-overlay-login .password-group span.iconpasswordeye").on("click", () => {
		const inputType = $("#personPassword1").prop("type")
		if (inputType === 'password') {
			$("#personPassword1").prop("type", "text");
			return;
		}

		$("#personPassword1").prop("type", "password");
	})

	$("#mobile-navbar .dropdown-content header span.iconclose, #miniCartMobile .mc-title .iconfechar").on("click", () => {
		closeAllNavbarMenu();
		inativeAllNavebarMenu();
	})

	function closeAllNavbarMenu () {
		$(`.dropdown.menu-user-dropdown`).removeClass("active");
		$(`.dropdown.menu-login-dropdown`).removeClass("active");
		$(`.dropdown.menu-search-dropdown`).removeClass("active");
		$(`.dropdown.menu-atendimento-dropdown`).removeClass("active");
		$(`.dropdown.menu-cart-dropdown`).removeClass("active");
		$('#overlay-geral').removeClass("active");
		$("html").css("overflow", "auto")
	}

	function inativeAllNavebarMenu () {
		const list = document.querySelectorAll("#mobile-navbar .list");
		list.forEach((item) => item.classList.remove("active"));
	}

	$('.menu-user-dropdown .categories-parent').on("click", () => {
		$('.list-categories-children').show();
		$('.list-categories-children').addClass('open');
		$('.list-categories').hide();
		$('.other-option').hide();
	})
	$('.menu-user-dropdown .categories-parent-back').on("click", () => {
		$('.list-categories-children').hide();
		$('.list-categories-children').removeClass('open');
		$('.list-categories').show();
		$('.other-option').show();
	})
	$('.menu-user-dropdown .manufactures-parent').on("click", () => {
		$('.list-manufactures-children').show();
		$('.list-manufactures-children').addClass('open');
		$('.list-categories').hide();
		$('.other-option').hide();
	})
	$('.menu-user-dropdown .manufactures-parent-back').on("click", () => {
		$('.list-manufactures-children').hide();
		$('.list-manufactures-children').removeClass('open');
		$('.list-categories').show();
		$('.other-option').show();
	})

	$('button.rastreio-desktop, button.rastreio-mobile').on("click", () => {
		$('.rastreio-modal').addClass('active');
		$('#overlay-geral').addClass("active");
		$("html").css("overflow", "hidden");
	})

	$('.rastreio-modal .iconfechar').on("click", () => {
		$('.rastreio-modal').removeClass('active');
		$('#overlay-geral').removeClass("active");
		$("html").css("overflow", "auto");
	})

	$('.informe-cep, .informe-cep-desktop').on("click", () => {
		$('.cep-modal').addClass('active');
		$('#overlay-geral').addClass("active");
		$("html").css("overflow", "hidden");
	})

	$('.cep-modal .iconfechar').on("click", () => {
		$('.cep-modal').removeClass('active');
		$('#overlay-geral').removeClass("active");
		$("html").css("overflow", "auto");
	})

	$(document).on("blur", ".form-search-header:visible input", function () {
		if ($(this).hasClass("active")) {
			$(this).removeClass("active");
			$(this).val("");
		}
	});

	// Copiar código do Pix Emv
	$(document).on('click', "button#pix-emv-code, button#copyable-code", function () {
		const button = $(this);
		const originalText = button.find('span').html();
		const value = button.val();
		if (copyTextToClipboard(value)) {
			button.find('span').html('Copiado!');
			setTimeout(function () {
				button.find('span').html(originalText);
			}, 2000);
		}
	});

	$('body').on('submit', 'form', function (event) {
		const form = $(this);
		console.log(form)
		if (["form-payment-gateway-card", "form-payment-gateway"].includes(form.attr('id'))) {
			pageLoadingOn();
			form.find("button[type=submit]").attr("disabled", true);
			return true;
		}

		if (!validateForm(form)) {
			return false;
		}

		if (form.attr("target") == undefined || form.attr("target") != "_blank") {
			pageLoadingOn();
		}

		if (form.find("input[name=g-recaptcha-response]").length == 1 && form.attr('id') != 'form-cielo' && form.attr('id') != 'form-paymet' && form.attr('id') != 'form-mercadopago') {

			//Google reCAPTCHA v3
			event.preventDefault();
			var gInput = form.find("input[name=g-recaptcha-response]");
			var site_key = gInput.attr("data-sitekey");
			var action_name = gInput.attr("data-action");
			grecaptcha.ready(function () {
				grecaptcha.execute(site_key, { action: action_name })
					.then(function (token) {
						gInput.val(token);
						var validacao = ajaxForms(form);
						if (!validacao) {
							return false;
						}
					});
			});
			//FIM Google reCAPTCHA v3
		} else {
			if (!ajaxForms(form)) {
				return false;
			}
		}
	});


	/**
	* Tabs
	*/
	$('.mkx-tabs a').click(function () {
		if (!$(this).hasClass('active')) {
			var tab = $(this).parent().parent().attr('data-tab'); // Referência a qual aba
			var panel = $(this).attr('data-panel'); // Referência a qual painel

			$(".mkx-tabs[data-tab='" + tab + "'] a").removeClass('active'); // Desmarca todos
			$(this).addClass('active'); // Marca o clicado

			$(".mkx-panes[data-tab='" + tab + "'] > div").hide().css({ 'paddingLeft': 25, 'opacity': 0 }); // Efeitos a gosto
			$(".mkx-panes[data-tab='" + tab + "'] #" + panel).css({ 'display': 'block' }).animate({ 'paddingLeft': 0, 'opacity': 1 }); // Efeitos a gosto
		}
	})

	/* [inicio] - Parallax */
	// if ($(".banner-parallax").length > 0) {
	// 	$(".img-parallax").css("background-image", "url(" + $(".banner-parallax").data("src") + ")");
	// 	var parallaxInicio = ($(".banner-parallax").offset().top - $(window).innerHeight());
	// 	var parallaxFinal = ($(".banner-parallax").offset().top + $(".banner-parallax").height());
	// 	var parallaxDiff = $(".banner-parallax").data("area") / (parallaxFinal - parallaxInicio);
	// 	if ($(window).scrollTop() > parallaxInicio && $(window).scrollTop() < parallaxFinal) {
	// 		var coords = 'center ' + (($(window).scrollTop() - parallaxInicio) * parallaxDiff + ((100 - $(".banner-parallax").data("area")) / 2)) + '%';
	// 		$(".img-parallax").css("background-position", coords);
	// 	}
	// }
	// $(window).scroll(function (event) {
	// 	if ($(".banner-parallax").length > 0) {
	// 		var parallaxInicio = ($(".banner-parallax").offset().top - $(window).innerHeight());
	// 		var parallaxFinal = ($(".banner-parallax").offset().top + $(".banner-parallax").height());
	// 		var parallaxDiff = $(".banner-parallax").data("area") / (parallaxFinal - parallaxInicio);
	// 		if ($(window).scrollTop() > parallaxInicio && $(window).scrollTop() < parallaxFinal) {
	// 			var coords = 'center ' + (($(window).scrollTop() - parallaxInicio) * parallaxDiff + ((100 - $(".banner-parallax").data("area")) / 2)) + '%';
	// 			$(".img-parallax").css("background-position", coords);
	// 		}
	// 	}
	// });

	showRatingWhenInView(".product-thumb-info .ratings .rating-box input");

	$(".insert-coupon label").on("click", () => {
		$(".insert-coupon .input-group-coupon").toggleClass("active")
	})

	/*
	* Countdown dos thumbs
	*/
	var os = $('.countdown');
 	if (os.length > 0) { 
		await import('jquery-countdown');
		for (var i = 0; i< os.length; i++){
			var o = $($('.countdown').get(i));
			var date = o.attr("data-data");
			var date2 = date.split(" ");
			var date3 = date2[0].split("-");
			var date4 = date2[1].split(":");
			var ano = parseInt(date3[0]);
			var mes = parseInt(date3[1])-1;
			var dia = parseInt(date3[2]);
			var hora = parseInt(date4[0]);
			var minuto = parseInt(date4[1]);
			const countTo = new Date(ano, mes, dia, hora);
			$(o).countdown(date)
				.on('update.countdown', function(event) {
					// Foramtação em https://hilios.github.io/jQuery.countdown/documentation.html
					// na seccção Formatter (event.strftime)
					let format = '%H:%M:%S';
					if(event.offset.totalDays > 0) {
						format = '%-n dia%!n ' + format;
					}
					$(this).html(event.strftime(format));
				})
				.on('finish.countdown', function(event) {
					$(this).html('Oferta Expirou!')
						.parent().addClass('disabled');
				});
		}
	 }

	 var os = $('.countdown-custom');
 	if (os.length > 0) { 
		await import('jquery-countdown');
		for (var i = 0; i< os.length; i++){
			var o = $($('.countdown-custom').get(i));
			var date = o.attr("data-data");
			var date2 = date.split(" ");
			var date3 = date2[0].split("-");
			var date4 = date2[1].split(":");
			var ano = parseInt(date3[0]);
			var mes = parseInt(date3[1])-1;
			var dia = parseInt(date3[2]);
			var hora = parseInt(date4[0]);
			var minuto = parseInt(date4[1]);
			const countTo = new Date(ano, mes, dia, hora);
			$(o).countdown(date)
				.on('update.countdown', function(event) {
					// Foramtação em https://hilios.github.io/jQuery.countdown/documentation.html
					// na seccção Formatter (event.strftime)
					let format = '%H:%M:%S';
					// if(event.offset.totalDays > 0) {
					// 	format = '%-n dia%!n ' + format;
					// }
					$(this).html(event.strftime(format));
				})
				.on('finish.countdown', function(event) {
					$(this).html('Oferta Expirou!')
						.parent().addClass('disabled');
				});
		}
	 }
	
	$('.bannerPrincipal').slick({
		dots: true,
		arrows: false,
		autoplay: true,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		touchThreshold: 1000,
		responsive: [
			{
				breakpoint: 2000,
				settings: {
					centerMode: false,
					centerPadding: '50px'
				}
			},
			{
				breakpoint: 3840,
				settings: {
					centerMode: true,
					centerPadding: '20%'
				}
			},
		],
	});

	$('.bannerPrincipalMobile').slick({
		dots: true,
		arrows: false,
		autoplay: true,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		touchThreshold: 1000,
		mobileFirst: true,
	});

	$('.banner-mini-carousel').slick({
		dots: false,
		arrows: false,
		infinite: false,
		autoplay: true,
		speed: 300,
		slidesToShow: 4,
		touchThreshold: 1000,
		slidesToScroll: 1,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: true,
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: true,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
				}
			}
		]
	});

	$('.banner-central-mini-carousel').slick({
		dots: false,
		arrows: false,
		infinite: false,
		autoplay: true,
		speed: 300,
		slidesToShow: 1,
		touchThreshold: 1000,
		slidesToScroll: 1,
		//lazyLoad: 'ondemand',
	});

	$('.big-manufactures-carousel').slick({
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: true,
		speed: 300,
		slidesToShow: 5,
		touchThreshold: 1000,
		slidesToScroll: 1,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					dots: true,
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: true,
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: true,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: true,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					centerMode: true,
				}
			}
		]
	});

	$('.featured-category-carousel').slick({
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 1,
		touchThreshold: 1000,
		slidesToScroll: 1,
		//lazyLoad: 'ondemand',
	});

	$('.slick-shop-info-1').slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: false,
        draggable: true,
        slidesToShow: 3,
        touchThreshold: 1000,
        slidesToScroll: 1,

		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					autoplay: true,
				}
			}
		]
    });


	$('.slick-shop-info-2').slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: false,
        draggable: true,
        slidesToShow: 4,
        touchThreshold: 1000,
        slidesToScroll: 1,

		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					autoplay: true,
				}
			}
		]
    });
	$(document).on("click", "#overlay-geral", closeAllMenus);

	$(document).on("click", ".openNav", () => openNav());
	$(document).on("click", ".closeNav", () => closeNav());

	// Abrir Dropdown Menu
	$(document).on("click", ".desktop-header ul li.user-dropdown .signin", function (e) {
		e.preventDefault();
		$(".desktop-header ul li.user-dropdown .dropdown-menu ").css("display", "block");
		$(".desktop-header ul li.user-dropdown .dropdown-menu ").addClass("active");
		$(".desktop-header ul li.user-dropdown .dropdown-menu ").css("visibility", "visible");
		$("#overlay-geral").addClass("active");
		$("html").css("overflow", "hidden")
	});
	// Fechar Dropdown Menu
	$(document).on("click", "#header .dropdownuserlogin > div span.iconfechar svg", function () {
		$(".desktop-header ul li.user-dropdown .dropdown-menu ").css("display", "none");
		$(".desktop-header ul li.user-dropdown .dropdown-menu ").css("visibility", "collapse");
		$(".desktop-header ul li.user-dropdown .dropdown-menu ").removeClass("active");
		$("#overlay-geral").removeClass("active");
		$("html").css("overflow", "auto")
	});

	// Fechar Menu clicando em qualquer lugar da página
	$(document).on("click", "#overlay-geral.active", function () {
		if ($(".desktop-header ul li.user-dropdown .dropdown-menu").hasClass("active")) {
			$("#header .dropdownuserlogin > div span.iconfechar svg").trigger("click");
		}

		closeAllNavbarMenu()
		inativeAllNavebarMenu()
		$('.cep-modal').removeClass('active');
		$('.rastreio-modal').removeClass('active');
		$('#header .dropdown-atendimento').removeClass("active");
	});


	$(document).on("click", ".desktop-header ul li.atendimento .iconatendimento", function (e) {
		e.preventDefault()
		$('#header .dropdown-atendimento').addClass("active");
		$("#overlay-geral").addClass("active");
		$("html").css("overflow", "hidden")
	})

	$('#header .dropdown-atendimento .iconclose').on("click", () => {
		$('#header .dropdown-atendimento').removeClass("active");
		$("#overlay-geral").removeClass("active");
		$("html").css("overflow", "auto")
	})

	$('#desktop-menu-header .menu-cat-tab.tab-cat').on("mouseover", () => {
		closeTabs()
		$('#desktop-menu-header .panel-cat').addClass("active")
	})
	$('#desktop-menu-header .menu-cat-tab.tab-marcas').on("mouseover", () => {
		closeTabs()
		$('#desktop-menu-header .panel-marcas').addClass("active")
	})

	function closeTabs() {
		$('#desktop-menu-header .panel-cat').removeClass("active")
		$('#desktop-menu-header .panel-marcas').removeClass("active")

	}

	$(".product-thumb .product-thumb-purchase .mc-qtd-btns .qtd_add").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();
		const mc_lid = $(this).attr("data-thumbproductid");
		const productThumb = $(this).closest(".product-thumb");
		const element_qtd = productThumb.find("input[name=amount].qtd_number");
		const supply = $(this).siblings('input[name=amount]').data('supply')
		var amount = element_qtd.val();
		const period = productThumb.find("input[data-period]").attr('data-period');

		if (amount < supply || period > 0) {
			element_qtd.val(++amount);
			if (!$(this).closest('.product-thumb-info').find('.alertsupply').hasClass('displaynone')) {
				$(this).closest('.product-thumb-info').find('.alertsupply').addClass('displaynone')
			}
		} else {
			$(this).closest('.product-thumb-info').find('.alertsupply').removeClass('displaynone')
		}

	});

	$(document).on("click", ".product-thumb .product-thumb-purchase .mc-qtd-btns .qtd_rem", function(){
		const mc_lid = $(this).attr("data-thumbproductid");
		const element_qtd = $(this).closest(".product-thumb").find("input[name=amount].qtd_number");
		const supply = $(this).siblings('input[name=amount]').data('supply')
		var amount = element_qtd.val()
		if(amount > 1){
			element_qtd.val(--amount);
			if(!$(this).closest('.product-thumb-info').find('.alertsupply').hasClass('displaynone')) {
				$(this).closest('.product-thumb-info').find('.alertsupply').addClass('displaynone')
			}
		}
	});

	$('.overlay-maioridade .btn-sim').on("click", () => {
		$('.overlay-maioridade').hide()
	})

	/* add-cart no thumb */
	$(document).on("click", ".product-thumb-purchase button.add-cart", function () {
		if (!$(this).hasClass('nosupply')) {
			const tiposku = $(this).parent().attr("data-sku");
			const idsku = $(this).attr("data-thumbskuid");
			const idprod = $(this).attr("data-thumbproductid");
			const amount = $(this).closest(".product-thumb").find("input[name=amount].qtd_number").val();
			const addthumb = false;

			if ($(".thumbid" + idprod + " .product-thumb-sku ul li").hasClass("disabled")) {
				return false;
			} else {
				$(".thumbid" + idprod + " .product-thumb-sku ul li").addClass("disabled");
			}

			if (tiposku != undefined) {
				var parentsku = "";
				if (tiposku == "sku1") {
					parentsku = "2";
				} else {
					parentsku = "1";
				}
				$("[data-sku=" + tiposku + "] li").removeClass("actived");
				$(this).attr("disabled", false);
				$(this).addClass("actived");
				var skurelations = $(this).attr("data-skurelations").split(',');
				$("[data-sku=sku" + parentsku + "] li").each(function (i) {
					if (skurelations.includes($(this).attr("data-thumbskuid")) == false) {
						$(this).removeClass("actived");
						$(this).attr("disabled", true);
					} else {
						$(this).attr("disabled", false);
					}
				});
				var sku1 = $("[data-sku=sku1] li.actived");
				var sku2 = $("[data-sku=sku2] li.actived");
				if (sku1 != undefined && sku2 != undefined) {
					var sku1id = sku1.attr("data-thumbskuid");
					var sku2id = sku2.attr("data-thumbskuid");
					if (tiposku == "sku1") {
						if (skurelations.includes(sku2id)) {
							addCart(idprod, sku1id, sku2id, amount);
						} else {
							$("[data-sku=sku2] li").removeClass("actived");
						}
					} else {
						if (skurelations.includes(sku1id)) {
							addCart(idprod, sku1id, sku2id, amount);
						} else {
							$("[data-sku=sku1] li").removeClass("actived");
						}
					}
				}
			} else {
				addCart(idprod, idsku, "", amount);
			}
		}
	});

	$('.thumb-centro').on("click", function (){
		$(this).siblings(".video-centro").html('<iframe title="Centro de Distribuição" width="350" height="180" alt="Vídeo Casa da Bebida" src="https://www.youtube.com/embed/ppwr8s2RGj8"></iframe>')
		$(this).hide()
	})

	$('.thumb-loja').on("click", function (){
		$(this).siblings(".video-loja").html('<iframe title="Loja Conceito" width="350" height="180" alt="Vídeo Casa da Bebida" src="https://www.youtube.com/embed/2_2PlzcX8T0"></iframe>')
		$(this).hide()
	})

	/*
	* checkbox receber noticias checkout 
	*/
	$('.recive-news-container').on('click',function(){ 
		var checkbox = $(this).find('#reciveNews');

		if(checkbox.prop('checked')){
			checkbox.attr('checked','checked')
			sessionStorage.setItem("reciveNews", "true")
		}else{
			checkbox.removeAttr('checked');
			sessionStorage.setItem("reciveNews", "false")
		}
	})

	$(window).on("scroll", () => {
		
		if ($(this).scrollTop() >= 300) {
			$('#barra-fixa-carrinho').addClass("active")

			if($(window).scrollTop() + $(window).height() == $(document).height()) {
				$('#barra-fixa-carrinho').removeClass("active")
			}else {
				$('#barra-fixa-carrinho').addClass("active")
			}
		} else {
			$('#barra-fixa-carrinho').removeClass("active")
		}
	})

	// Salva promotion_id / promotion_name ao clicar no banner na sessão para serem acessíveis na purchase-order e mandar os dados para o Analytics.
	$('.bannerPrincipal picture , .bannerPrincipalMobile picture , #big-manufactures .big-manufactures-card , #banners-mini picture, .banner-central-mini-carousel picture, .banners-destaque a').on('click', e => {
		
		let promotion_id = $(e.currentTarget).attr("data-promotionid");
		let promotion_name = $(e.currentTarget).attr("data-promotionname");
		$.ajax({
			url: '/', 
			type: 'POST',
			data: {
				promotion_id: promotion_id,
				promotion_name: promotion_name
			},
			success: function(response) {
				// console.log("Resposta recebida:", response);
			},
			error: function(error) {
				// console.error("Erro na requisição:", error);
			}
		});
    });

	$('.comments .reply').on('click', function() {
		$(this).siblings('.wrapper-reply').addClass('active')
		$(this).hide();
	});

	$('body').on('submit', '.feedback form', function (e) {
		e.preventDefault();
		const form = $(this);
		var data = form.serialize();
		$.ajax({
			type: "POST",
			data: data,
			dataType: "json",
			success: function (res) {
				if (res.error != undefined) {
					alert(subjson.error);
				} else if(res.location != undefined){
					// Efetuar Login
					window.location.href = res.location;
					return false;
				} else if( res.comment != undefined){
					$(".comments .default-comment .name").text(res.comment.name);
					$(".comments .default-comment .date").text(res.comment.date);
					$(".comments .default-comment .description").text(res.comment.description);
					$(".comments .wrapper-comments").append($(".default-comment").html());

					form.find('.main-alert').slideUp();
					form.find('.form-success').removeClass('displaynone');
					form.find('.form-success').html('<a class="close" title="Fechar">×</a>');
					form.find('.form-success').append(res.success);
					form.find('.form-success').fadeIn();
					form.trigger("reset");
					pageLoadingOff();
				}
			},
			error: function(){
				form.find('.form-success').slideUp();
				form.find('.main-alert').html('<a class="close" title="Fechar">×</a>');
				form.find('.main-alert').append('Erro, tente denovo!');
				form.find('.main-alert').removeClass("displaynone");
				pageLoadingOff();
				return false;
			}
		});
	});
	$('body').on('submit', '.comment form', function (e) {
		e.preventDefault();
		const form = $(this);
		var data = form.serialize();
		$.ajax({
			type: "POST",
			data: data,
			dataType: "json",
			success: function (res) {
				if (res.error != undefined) {
					alert(subjson.error);
				} else if(res.location != undefined){
					// Efetuar Login
					window.location.href = res.location;
					return false;
				} else if( res.comment != undefined){
					$(".comments .default-sub-comment .name").text(res.comment.name);
					$(".comments .default-sub-comment .date").text(res.comment.date);
					$(".comments .default-sub-comment .description").text(res.comment.description);
					var commentId = form.find("input[name=top]").val();
					$(".comments .wrapper-comments").find('[data-value='+ commentId + '] .subComments').append($(".default-sub-comment").html());

					form.find('.main-alert').slideUp();
					form.find('.form-success').removeClass('displaynone');
					form.find('.form-success').html('<a class="close" title="Fechar">×</a>');
					form.find('.form-success').append(res.success);
					form.find('.form-success').fadeIn();
					form.trigger("reset");
					pageLoadingOff();
				}
			},
			error: function(){
				form.find('.form-success').slideUp();
				form.find('.main-alert').html('<a class="close" title="Fechar">×</a>');
				form.find('.main-alert').append('Erro, tente denovo!');
				form.find('.main-alert').removeClass("displaynone");
				pageLoadingOff();
				return false;
			}
		});
	});

	$('a.cupom-floater i.iconfechar').on('click', function(e) {
		e.preventDefault();
		$(this).parent().addClass('d-none');
	})
	
		$('.categories-carousel').slick({
		dots: true,
		arrows: true,
		infinite: true,
		autoplay: false,
		speed: 300,
		slidesToShow: 8,
		touchThreshold: 1000,
		slidesToScroll: 8,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 6,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			}
		]
	});

	$('button[data-bs-toggle="tab"]').on('click', function (e) {
		$('.categories-carousel').slick('refresh');
	})

	$('.destaque-carousel').slick({
		dots: false,
		arrows: true,
		infinite: true,
		autoplay: false,
		speed: 300,
		slidesToShow: 4,
		touchThreshold: 1000,
		slidesToScroll: 1,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: true,
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: true,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: true,
				}
			}
		]
	});

	$('button[data-bs-toggle="tab"]').on('click', function (e) {
		$('.destaque-carousel').slick('refresh');
		lozadObsever.observe();
	})
	
		$('.coupom-carousel').slick({
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 7,
		touchThreshold: 1000,
		slidesToScroll: 2,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});

	$("#pills-coupom-tab").on('click', function(){
		setTimeout(()=>{
			$('.coupom-carousel').slick('refresh');
		}, 100)
	})


	$(document).on('click', ".coupom-carousel .coupom", function(){
		const coupomId = $(this).attr('data-id');
		const link = $(this).attr('data-link');

		const img = `/img/black-november/popup${coupomId}.png`;
		
		if(link){
			$(".pop-up-coupom a").attr("href", link).attr("target", "_blank")
		}else{
			$(".pop-up-coupom a").removeAttr("href").removeAttr("target");
		}

		$(".pop-up-coupom")
		.removeClass('d-none')
		.find("img")
		.attr('src', img)

	});

	$(".pop-up-coupom").on("click", function(e) {
		if (!$(e.target).is("img")) {
			e.preventDefault();
			$(this).addClass("d-none");
		}
	});


	ofortasRelampagoContador();
	setInterval(ofortasRelampagoContador, 1000)

	/* Efeito Carnaval P
	 */
	// const isCartOrCheckout = window.location.pathname.includes('/carrinho') || window.location.pathname.includes('/finalizar-compra');

	// if (!isCartOrCheckout) {
	// 	const maxVisibleSnowflakes = 20;
	// 	let snowflakesOnScreen = [];

	// 	const carnivalOptions = ['🎉', '🥁', '🪅', '🎊', '✨'];
	// 	const overlay = $('<div id="snow-overlay"></div>');
	// 	$('body').append(overlay);

	// 	function createSnowflakes() {
	// 		if (snowflakesOnScreen.length < maxVisibleSnowflakes) {
	// 			const snowflake = document.createElement("div");
	// 			snowflake.classList.add("snowflake");

	// 			const selectedEmoji = carnivalOptions[Math.floor(Math.random() * carnivalOptions.length)];
	// 			snowflake.innerHTML = selectedEmoji;
	// 			snowflake.style.fontSize = `${Math.floor(Math.random() * 20) + 30}px`;

	// 			snowflake.style.left = `${Math.random() * 100}vw`;
	// 			snowflake.style.animationDuration = `${Math.random() * 10 + 7}s`;
	// 			overlay.append(snowflake);

	// 			snowflakesOnScreen.push(snowflake);
	// 		}
	// 	}

	// 	function removeAllSnowflakes() {
	// 		snowflakesOnScreen.forEach((snowflake) => {
	// 			snowflake.style.transition = "opacity 1s, transform 1s";
	// 			snowflake.style.opacity = "0";
	// 			snowflake.style.transform = "scale(0)";
	// 			setTimeout(() => {
	// 				snowflake.remove();
	// 			}, 1000);
	// 		});
	// 		snowflakesOnScreen = [];
	// 	}

	// 	let snowflakeInterval = setInterval(createSnowflakes, 500);

	// 	setTimeout(() => {
	// 		clearInterval(snowflakeInterval);
	// 		removeAllSnowflakes();
	// 		setTimeout(() => {
	// 			overlay.remove();
	// 		}, 1500);
	// 	}, 20000);
	// }
});

function ofortasRelampagoContador(){
	const now = new Date();
	const midNight = new Date();
	midNight.setHours(24,0,0,0);

	const diff = midNight - now;

	let hour = Math.floor(diff / 1000 / 60 / 60);
	let minutes = Math.floor((diff / 1000 / 60) % 60);
	let seconds = Math.floor((diff / 1000) % 60);
	
	hour = hour < 10 ? "0"+hour : hour;
	minutes = minutes < 10 ? "0"+minutes : minutes;
	seconds = seconds < 10 ? "0"+seconds : seconds;

	$(".time-container .hour").html(hour);
	$(".time-container .minutes").html(minutes);
	$(".time-container .seconds").html(seconds);
}

if ($('.menu-cart-dropdown').length > 0) {
	// Ajuste para sempre carregar as img lozad ao abrir o carrinho lateral
	const observer = new MutationObserver(() => {
		if ($('#miniCart').hasClass('aberto')) {
			lozad('#miniCart .lozad').observe();
		}
	});

	observer.observe($('#miniCart')[0], { attributes: true, attributeFilter: ['class'] });

	const observerMobile = new MutationObserver(() => {
		if ($('.menu-cart-dropdown').hasClass('active')) {

			lozad('.menu-cart-dropdown .lozad').observe();
		}
	});

	observerMobile.observe($('.menu-cart-dropdown')[0], { attributes: true, attributeFilter: ['class'] });
}

document.querySelectorAll('.lazy-loader').forEach(function (button) {
	button.disabled = true;
	button.classList.add('loading-button')
});

document.addEventListener('DOMContentLoaded', () => {
	sendPersonDataDatalayerEvent();
});

async function  sendPersonDataDatalayerEvent(){
	if (!(await shouldSave())) return;
	savePersonDataOnLocalStorage().then(() => {
		const stored = localStorage.getItem("personData");
		if (stored) {
			console.log("enviando evento person_data")
			DataLayerEvents.personData(JSON.parse(stored));
		}
	});
}

async function savePersonDataOnLocalStorage(){
	let {first_name: firstName, last_name: lastName, email, telefone: phone, cep:postalCode } = JSON.parse(document.querySelector("#personData").textContent);
	
	const personData = {
		firstName,
		lastName,
		email,
		phone,
		postalCode
	}
	
	const promises = Object.entries(personData).map(async ([key, value]) => {
    const hash = await generateSha256(value.toLowerCase().replace(/\(|\)|\s+|\-/g, ""));
    return [key, hash];
  });

	const hashedEntries = await Promise.all(promises);
  
  const finalData = Object.fromEntries(hashedEntries);
  localStorage.setItem("personData", JSON.stringify(finalData));
	 
}

const shouldSave = async () => {
	const element = document.querySelector("#personData");
	const localData = localStorage.getItem("personData");

	if (!element) return false;

	if (!localData) return true;

	try {
		const remoteData = JSON.parse(element.textContent);
		const storedData = JSON.parse(localData);

		const remoteEmailHash = await generateSha256(remoteData.email.toLowerCase().replace(/\(|\)|\s+|\-/g, ""));

		return storedData.email !== remoteEmailHash;
	} catch (error) {
		console.error("Erro ao processar JSON ou Hash:", error);
		return false;
	}
};
